import styled from 'styled-components';

export const Input = styled.input`
  display: flex;
  height: 2.5rem;
  width: 100%;
  border-radius: ${props => props.theme.borderRadius.md};
  border: 1px solid ${props => props.theme.colors.input};
  background-color: ${props => props.theme.colors.background};
  padding: 0.5rem 0.75rem;
  font-size: 0.9375rem;
  line-height: 1.5rem;
  color: ${props => props.theme.colors.foreground};
  transition: all 0.2s;
  
  @media (min-width: 768px) {
    font-size: 1rem;
    height: 2.75rem;
    padding: 0.625rem 1rem;
  }
  
  @media (min-width: 1024px) {
    font-size: 1.0625rem;
    height: 3rem;
    padding: 0.75rem 1.25rem;
  }
  
  @media (min-width: 1440px) {
    font-size: 1.125rem;
    height: 3.25rem;
  }
  
  &::placeholder {
    color: ${props => props.theme.colors.mutedForeground};
  }
  
  &:focus-visible {
    outline: 2px solid ${props => props.theme.colors.ring};
    outline-offset: 2px;
    border-color: ${props => props.theme.colors.ring};
  }
  
  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;


